import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganisationIndexGroupMapper from "../service/OrganisationIndexGroupMapper";
import OrganisationIndexGroupParamMapper from "../service/OrganisationIndexGroupParamMapper";

export default class UpdateOrganisationIndexGroupInteractor {
  private updateResource: UpdateResourceInteractor<IOrganisationIndexGroup>;

  constructor({ updateResource }: any) {
    this.updateResource = updateResource;
  }

  async execute(model: IOrganisationIndexGroup) {
    const result = await this.updateResource.execute(
      `organisations/${model.organisationId}/groups`,
      OrganisationIndexGroupMapper,
      OrganisationIndexGroupParamMapper,
      model,
      model.id,
      undefined,
      false
    );

    return result;
  }
}
